import { render, staticRenderFns } from "./select_box.vue?vue&type=template&id=78955785&scoped=true"
import script from "./select_box.vue?vue&type=script&lang=js"
export * from "./select_box.vue?vue&type=script&lang=js"
import style0 from "./select_box.vue?vue&type=style&index=0&id=78955785&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78955785",
  null
  
)

export default component.exports